/* Draft-theme Kaching integration. Kaching remains responsible for variants,
   pricing, discounts and submission. Its exported items() method includes all
   selected bundle products, unlike the native quantity input alone. */
(function () {
  window.__bfeJewelleryPairDefaultsV2 = true;
  var buttonSelector = 'buy-buttons[data-bfe-meal-button]';
  if (!document.querySelector(buttonSelector)) return;
  var scheduled = false;
  var stickyVisibilityScheduled = false;
  var guardedBundles = new WeakSet();
  var purchaseActionMarkers = new WeakMap();
  var newTeePairDefaultApplied = false;
  var jewelleryPairDefaultStates = new WeakMap();
  var jewelleryPairDefaults = {
    'original-necklace': 'infinity-butterfly-necklace',
    'infinity-butterfly-necklace': 'original-necklace',
    'cross-of-hope': 'original-necklace',
    'promise-bracelet': 'original-necklace'
  };
  var newTeeHandles = [
    'good-energy-only-t-shirt',
    'kindness-never-wasted-t-shirt',
    'kindness-new-cool-t-shirt',
    'love-strongest-language-t-shirt',
    'love-louder-t-shirt',
    'tiny-wings-t-shirt',
    't-shirt-of-kindness'
  ];

  function selectNewTeePairDefault(widget) {
    if (newTeePairDefaultApplied) return;
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match || newTeeHandles.indexOf(match[1]) === -1) return;

    var bars = widget.querySelectorAll('.kaching-bundles__bar');
    var pair = bars[1];
    if (!pair || !/Original Necklace/i.test(pair.textContent)) return;

    if (pair.classList.contains('kaching-bundles__bar--selected')) {
      newTeePairDefaultApplied = true;
      return;
    }

    var control = pair.querySelector('[role="button"]');
    if (!control) return;
    newTeePairDefaultApplied = true;
    control.click();
  }

  function selectJewelleryPairDefault(widget) {
    if (jewelleryPairDefaultStates.has(widget)) return;

    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var primaryHandle = match && match[1];
    var targetHandle = primaryHandle && jewelleryPairDefaults[primaryHandle];
    if (!targetHandle) return;

    var state = { stage: 'waiting', finish: '', modal: null };
    var timer;
    var poll;
    var style = document.createElement('style');
    style.textContent = 'html[data-bfe-seeding-jewellery-pair] .kaching-bundles__choose-product-modal { visibility: hidden; }';
    jewelleryPairDefaultStates.set(widget, state);
    widget.setAttribute('data-bfe-default-pair', 'loading');

    // Kaching first paints the shared two-piece offer with its second slot
    // unresolved. Keep the purchase action unavailable until the agreed
    // complementary product and matching finish are actually present.
    var purchaseAction = widget.closest('.product-info')?.querySelector('.product-info__buy-buttons');
    if (purchaseAction) {
      purchaseAction.setAttribute('data-bfe-pair-loading', '');
      purchaseAction.setAttribute('inert', '');
    }

    function finish(status) {
      observer.disconnect();
      window.clearTimeout(timer);
      window.clearInterval(poll);
      widget.removeEventListener('pointerdown', onInteraction, true);
      widget.removeEventListener('keydown', onInteraction, true);
      document.documentElement.removeAttribute('data-bfe-seeding-jewellery-pair');
      style.remove();
      widget.setAttribute('data-bfe-default-pair', status);
      if (purchaseAction) {
        purchaseAction.removeAttribute('data-bfe-pair-loading');
        purchaseAction.removeAttribute('inert');
      }
      state.stage = 'finished';
      scheduleUpdate();
    }

    function onInteraction(event) {
      if (event.isTrusted && state.stage !== 'finished') finish('customer-selected');
    }

    function selectedPairBar() {
      return Array.prototype.find.call(widget.querySelectorAll('.kaching-bundles__bar'), function (bar) {
        var heading = bar.querySelector('.kaching-bundles__bar-title, .kaching-bundles__bar-main');
        return /Any\s*2\s*Pieces/i.test((heading || bar).textContent || '');
      });
    }

    function step() {
      if (state.stage === 'finished') return;
      var bar = selectedPairBar();
      if (!bar) return;

      if (!bar.classList.contains('kaching-bundles__bar--selected')) {
        if (state.stage !== 'waiting') return;
        var selectPair = bar.querySelector('.kaching-bundles__bar-main, [role="button"]');
        if (selectPair) selectPair.click();
        return;
      }

      var pieces = bar.querySelectorAll('.kaching-bundles__collection-product');
      var first = pieces[0];
      var second = pieces[pieces.length - 1];
      if (second && second.querySelector('a[href*="/products/' + targetHandle + '"]')) return finish('ready');

      if (state.stage === 'waiting') {
        if (!second || !second.querySelector('a[href*="/products/' + primaryHandle + '"]')) return;
        state.finish = first && first.querySelector('.kaching-bundles__bar-variant-select')?.value || '';
        var remove = second.querySelector('.kaching-bundles__collection-product__remove-button');
        if (!remove) return;
        state.stage = 'choose';
        document.head.append(style);
        document.documentElement.setAttribute('data-bfe-seeding-jewellery-pair', '');
        remove.click();
        return;
      }

      state.modal = document.querySelector('.kaching-bundles__choose-product-modal');
      if (state.stage === 'choose') {
        if (state.modal) {
          state.stage = 'modal';
          return;
        }
        var chooser = bar.querySelector('.kaching-bundles__collection-product__choose-product-button');
        if (chooser) chooser.click();
        return;
      }

      if (state.stage === 'modal') {
        if (!state.modal) return;
        var link = state.modal.querySelector('a[href*="/products/' + targetHandle + '"]');
        var card = link && link.closest('.kaching-bundles__choose-product__product');
        var select = card && card.querySelector('.kaching-bundles__bar-variant-select');
        if (!card) return;
        if (select && state.finish && Array.prototype.some.call(select.options, function (option) { return option.value === state.finish; })) {
          if (select.value !== state.finish) {
            select.value = state.finish;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        state.stage = 'select-product';
        return;
      }

      if (state.stage === 'select-product') {
        state.modal = document.querySelector('.kaching-bundles__choose-product-modal');
        var targetLink = state.modal && state.modal.querySelector('a[href*="/products/' + targetHandle + '"]');
        var targetCard = targetLink && targetLink.closest('.kaching-bundles__choose-product__product');
        var choose = targetCard && targetCard.querySelector('.kaching-bundles__choose-product__product-button');
        if (choose && choose.getAttribute('aria-disabled') !== 'true') {
          state.stage = 'verify';
          choose.click();
        }
        return;
      }

      if (state.stage === 'verify') {
        var selected = bar.querySelector('.kaching-bundles__collection-product a[href*="/products/' + targetHandle + '"]');
        if (!selected) return;
        var selectedCard = selected.closest('.kaching-bundles__collection-product');
        var selectedFinish = selectedCard && selectedCard.querySelector('.kaching-bundles__bar-variant-select');
        if (!state.finish || !selectedFinish || selectedFinish.value === state.finish) finish('ready');
      }
    }

    var observer = new MutationObserver(step);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'collection-breaks-products'] });
    widget.addEventListener('pointerdown', onInteraction, true);
    widget.addEventListener('keydown', onInteraction, true);
    timer = window.setTimeout(function () {
      state.modal?.querySelector('.kaching-bundles__choose-product__close')?.click();
      finish('unavailable');
    }, 30000);
    poll = window.setInterval(step, 100);
    step();
  }

  function positiveNumber(value, fallback) {
    var number = parseInt(value, 10);
    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function displayedPriceAmount(value) {
    var numeric = String(value || '').replace(/[\s\u00a0'’]/g, '').replace(/[^\d.,-]/g, '');
    if (!numeric) return NaN;
    var comma = numeric.lastIndexOf(',');
    var dot = numeric.lastIndexOf('.');
    var decimal = comma > dot ? ',' : '.';
    var decimalIndex = Math.max(comma, dot);
    var decimalDigits = decimalIndex >= 0 ? numeric.length - decimalIndex - 1 : 0;
    if (comma >= 0 && dot >= 0) {
      numeric = numeric.replace(decimal === ',' ? /\./g : /,/g, '').replace(decimal, '.');
    } else if (decimalIndex >= 0 && decimalDigits > 0 && decimalDigits <= 2) {
      numeric = numeric.replace(decimal, '.');
    } else {
      numeric = numeric.replace(/[.,]/g, '');
    }
    return parseFloat(numeric);
  }

  function linkedFields(formId, selector) {
    var escapedId = window.CSS && CSS.escape ? CSS.escape(formId) : formId.replace(/(["\\])/g, '\\$1');
    var form = document.getElementById(formId);
    var fields = form ? Array.prototype.slice.call(form.querySelectorAll(selector)) : [];
    Array.prototype.slice.call(document.querySelectorAll(selector + '[form="' + escapedId + '"]')).forEach(function (field) {
      if (fields.indexOf(field) === -1) fields.push(field);
    });
    return fields.filter(function (field) { return !field.disabled; });
  }

  function bundleForForm(formId) {
    var form = document.getElementById(formId);
    var info = form && form.closest('.product-info');
    return info && info.querySelector('kaching-bundles-block');
  }

  function bundleQuantity(widget) {
    if (!widget || typeof widget.items !== 'function') return 0;
    try {
      var items = widget.items();
      return Array.isArray(items) ? items.reduce(function (sum, item) {
        return sum + positiveNumber(item.quantity, 0);
      }, 0) : 0;
    } catch (error) {
      // The app may still be mounting or replacing its product data.
      return 0;
    }
  }

  function completeFixedBundle(widget) {
    try {
      var deals = widget.dealBlock && widget.dealBlock.dealBars;
      var selectedId = widget.selectedDealBarId;
      var deal = Array.isArray(deals) && deals.find(function (entry) { return entry.id === selectedId; });
      if (!deal || deal.dealBarType !== 'bundle' || !Array.isArray(deal.bundleProducts) || !deal.bundleProducts.length) return false;

      var items = widget.items();
      var products = [widget.product].concat(widget.otherProducts || []).filter(Boolean);
      if (!Array.isArray(items) || !items.length) return false;

      // Only accept items already produced by the app for this exact fixed set.
      // This also prevents stale items from the previously selected offer passing.
      if (!items.every(function (item) {
        var data = JSON.parse(item.properties && item.properties.__kaching_bundles || '{}');
        return item.id && positiveNumber(item.quantity, 0) && data.bar === selectedId;
      })) return false;

      var remaining = items.map(function (item) { return { id: String(item.id), quantity: Number(item.quantity) }; });
      return deal.bundleProducts.every(function (entry) {
        var productId = String(entry.productGID || '').split('/').pop();
        var product = entry.productGID === 'default' ? widget.product : products.find(function (candidate) {
          return String(candidate.id) === productId;
        });
        var needed = positiveNumber(entry.quantity, 0);
        if (!product || !Array.isArray(product.variants) || !needed) return false;
        remaining.forEach(function (item) {
          var allowed = !Array.isArray(entry.variantGIDs) || entry.variantGIDs.some(function (gid) {
            return String(gid).split('/').pop() === item.id;
          });
          if (!allowed || !product.variants.some(function (variant) { return String(variant.id) === item.id; })) return;
          var used = Math.min(needed, item.quantity);
          needed -= used;
          item.quantity -= used;
        });
        return needed === 0;
      });
    } catch (error) {
      return false;
    }
  }

  function installBundleValidationGuard(widget) {
    if (guardedBundles.has(widget) || typeof widget.items !== 'function' ||
        typeof widget.validateItemSelection !== 'function' || typeof widget.isItemSelectionValid !== 'function') return;

    // Kaching currently retains collection-break selection validation when
    // switching from an unfinished Choose Any 2 to a fixed product bundle.
    // Scope that validation to the offer it belongs to. Never bypass the chooser
    // for quantity/mix-and-match offers, or an incomplete fixed bundle. Cart and
    // discount handling remain entirely with the app and Shopify.
    ['validateItemSelection', 'isItemSelectionValid'].forEach(function (method) {
      var original = widget[method];
      Object.defineProperty(widget, method, {
        configurable: true,
        value: function () {
          if (completeFixedBundle(widget)) return method === 'validateItemSelection' ? { valid: true, message: null } : true;
          return original.apply(widget, arguments);
        }
      });
    });
    guardedBundles.add(widget);
  }

  function formQuantity(formId) {
    var selectedBundleQuantity = bundleQuantity(bundleForForm(formId));
    if (selectedBundleQuantity > 0) return selectedBundleQuantity;

    var appItemQuantities = linkedFields(formId, 'input[name^="items["][name$="[quantity]"]');
    if (appItemQuantities.length) {
      var appTotal = appItemQuantities.reduce(function (sum, field) {
        return sum + positiveNumber(field.value, 0);
      }, 0);
      if (appTotal > 0) return appTotal;
    }

    var quantityFields = linkedFields(formId, 'input[name="quantity"]');
    return quantityFields.length ? positiveNumber(quantityFields[0].value, 1) : 1;
  }

  function updateButton(wrapper) {
    var formId = wrapper.getAttribute('form');
    var mealsPerProduct = positiveNumber(wrapper.getAttribute('data-bfe-meals-per-product'), 20);
    var quantity = formId ? formQuantity(formId) : 1;
    var widget = formId ? bundleForForm(formId) : null;
    var preparingPair = widget && widget.getAttribute('data-bfe-default-pair') === 'loading';
    var incomplete = widget && widget.hasAttribute('data-bfe-incomplete');
    var label = preparingPair ? 'Preparing Your Pair…' : incomplete ? 'Choose Second Piece' :
      'Add to Cart + Fund ' + (quantity * mealsPerProduct) + ' Meals';
    var button = wrapper.querySelector('button[type="submit"]');

    if (!button) return;

    // Kaching keeps the native button actionable after a shopper removes the
    // second item. Prevent the resulting silent no-op until the pair is whole.
    // Only release disabled state applied here; native availability remains the
    // responsibility of Shopify and Kaching.
    var disabledByIncomplete = button.hasAttribute('data-bfe-incomplete-disabled');
    if (incomplete && !button.disabled && button.getAttribute('aria-disabled') !== 'true') {
      button.setAttribute('data-bfe-incomplete-disabled', '');
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    } else if (!incomplete && disabledByIncomplete) {
      button.removeAttribute('data-bfe-incomplete-disabled');
      button.disabled = false;
      button.removeAttribute('aria-disabled');
    }

    // Change only the text node. Replacing button.textContent destroys both
    // Impact's loading element and Butterfly's cursor-origin fill animation.
    var walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.parentElement.closest('.button__loader, .button__feedback, .bfe-origin__fill')) continue;
      if (/add to cart|preparing your pair|choose second piece/i.test(node.textContent)) {
        if (node.textContent.trim() !== label) node.textContent = label;
        break;
      }
    }
  }

  function updateBundleLabels(widget) {
    var info = widget.closest('.product-info');
    var wrapper = info && info.querySelector(buttonSelector);
    var deals = widget.dealBlock && widget.dealBlock.dealBars;
    if (!wrapper || !Array.isArray(deals)) return;
    var productPathMatch = window.location.pathname.match(/\/products\/([^/?#]+)/);
    var useOriginalRecoveryCopy = !document.querySelector('buy-buttons[template="atc-demo"]') &&
      new URLSearchParams(window.location.search).get('view') !== 'atc-demo' &&
      window.matchMedia('(max-width: 699px)').matches &&
      productPathMatch &&
      ['the-original-necklace', 'necklace', 'original-necklace', 'original-necklace-redesign'].indexOf(productPathMatch[1]) !== -1;
    var meals = positiveNumber(wrapper.getAttribute('data-bfe-meals-per-product'), 20);
    widget.setAttribute('data-bfe-bundle', '');

    // One shared heading across Jewelry and apparel, scoped to this theme.
    // Keep the app's DOM markers intact so its own rerenders remain safe.
    var heading = widget.querySelector('.kaching-bundles__block-title');
    if (heading) {
      var titleNode = Array.prototype.find.call(heading.childNodes, function (node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });
      if (titleNode && titleNode.textContent !== 'Build Your Bundle') titleNode.textContent = 'Build Your Bundle';
    }

    widget.querySelectorAll('.kaching-bundles__bar-most-popular__content, .kaching-bundles__upsell__text').forEach(function (element) {
      Array.prototype.forEach.call(element.childNodes, function (node) {
        if (node.nodeType !== Node.TEXT_NODE) return;
        var text = node.textContent.trim();
        if (useOriginalRecoveryCopy && text === 'Most Popular') node.textContent = 'Double the Love';
        if (/^exclusive deal/i.test(text)) node.textContent = 'Multiply Your Impact';
        if (text === 'Add Original Necklace') node.textContent = 'Optional: Original Necklace';
      });
    });

    // Existing demo offers contain legacy 50/120/260-meal subtitles. Correct
    // quantity-break meal copy in this theme without editing live app offers.
    widget.querySelectorAll('[data-deal-bar-id]').forEach(function (bar) {
      // The app can retain a whitespace-only label after its copy is cleared.
      // Do not leave a small empty colored pill beside the offer title.
      var inlineLabel = bar.querySelector('.kaching-bundles__bar-label');
      if (inlineLabel) inlineLabel.style.display = inlineLabel.textContent.trim() ? '' : 'none';
      var deal = deals.find(function (entry) { return entry.id === bar.getAttribute('data-deal-bar-id'); });
      if (!deal) return;
      var quantity = deal.dealBarType === 'bundle' && Array.isArray(deal.bundleProducts) ?
        deal.bundleProducts.reduce(function (sum, entry) { return sum + positiveNumber(entry.quantity, 0); }, 0) :
        positiveNumber(deal.quantity, 0);
      var subtitle = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (deal.dealBarType === 'quantity-break' && quantity && subtitle && /meals?/i.test(subtitle.textContent)) {
        var label = 'Fund ' + (quantity * meals) + ' meals';
        if (subtitle.textContent !== label) subtitle.textContent = label;
      }

      var benefit = bar.querySelector('[data-bfe-bundle-card-value]');
      if (quantity < 2) {
        if (benefit) benefit.remove();
        return;
      }
      var current = displayedPriceAmount(bar.querySelector('.kaching-bundles__bar-price')?.textContent);
      var full = displayedPriceAmount(bar.querySelector('.kaching-bundles__bar-full-price')?.textContent);
      var discount = Number.isFinite(current) && Number.isFinite(full) && full > current ?
        Math.round((1 - current / full) * 100) : 0;
      if (!benefit) {
        var content = bar.querySelector('.kaching-bundles__bar-content-left');
        if (!content) return;
        benefit = document.createElement('div');
        benefit.className = 'bfe-bundle-card-value';
        benefit.setAttribute('data-bfe-bundle-card-value', '');
        var discountLabel = document.createElement('span');
        discountLabel.className = 'bfe-bundle-card-value__discount';
        benefit.appendChild(discountLabel);
        var deliveryLabel = document.createElement('span');
        deliveryLabel.className = 'bfe-bundle-card-value__delivery';
        deliveryLabel.textContent = 'Free delivery';
        benefit.appendChild(deliveryLabel);
        content.appendChild(benefit);
      }
      var discountLabel = benefit.querySelector('.bfe-bundle-card-value__discount');
      var discountText = discount ? discount + '% off' : 'Bundle saving';
      if (discountLabel && discountLabel.textContent !== discountText) discountLabel.textContent = discountText;
      var benefitLabel = discountText + ' and free delivery';
      if (benefit.getAttribute('aria-label') !== benefitLabel) benefit.setAttribute('aria-label', benefitLabel);
    });
  }

  function updateTwoPieceSwapControl(widget) {
    var deals = widget.dealBlock && widget.dealBlock.dealBars;
    var collectionBreaks = widget.dealBlock && widget.dealBlock.collectionBreaks;
    if (!collectionBreaks || !widget.dealBlock.collectionBreaksEnabled || !Array.isArray(deals)) return;

    var twoPieceDeal = deals.find(function (deal) {
      return deal.dealBarType === 'quantity-break' && positiveNumber(deal.quantity, 0) === 2;
    });
    if (!twoPieceDeal) return;

    var bar = widget.querySelector('.kaching-bundles__bar--selected[data-deal-bar-id="' + twoPieceDeal.id + '"]');
    if (!bar) return;

    bar.querySelectorAll('.kaching-bundles__collection-product__remove-button').forEach(function (control) {
      control.setAttribute('data-bfe-swap-control', '');
      control.setAttribute('data-bfe-swap-label', 'Swap');
      control.setAttribute('aria-label', 'Swap product');
      control.setAttribute('title', 'Swap product');
    });
  }

  function bundleSelection(widget) {
    var quantity = bundleQuantity(widget);
    var selected = widget.querySelector('.kaching-bundles__bar--selected');
    if (!selected || !quantity) return null;
    var missing = selected.querySelectorAll('.kaching-bundles__collection-product__choose-product-button').length;
    var incomplete = missing > 0;
    try {
      if (typeof widget.isItemSelectionValid === 'function' && !widget.isItemSelectionValid()) incomplete = true;
    } catch (error) {
      // An app remount must not prevent the native purchase flow from working.
      return null;
    }
    var total = '';
    var savingsAmount = '';
    var savingsPercent = 0;
    if (!incomplete && typeof widget.pricing === 'function') {
      try {
        var pricing = widget.pricing();
        var price = pricing.discountedPrice;
        if (price && Number.isFinite(price.amount) && price.amount >= 0 && typeof price.formatted === 'string') {
          // Keep the app's currency, rounding and discounts. Never recalculate
          // prices from offer labels or the native single-product price.
          total = new DOMParser().parseFromString(price.formatted, 'text/html').body.textContent.trim();
        }
        var fullPrice = pricing.fullPrice;
        var hasSaving = fullPrice && Number.isFinite(fullPrice.amount) && fullPrice.amount > 0 &&
          price && Number.isFinite(price.amount) && price.amount < fullPrice.amount;
        if (hasSaving) {
          var formattedFullPrice = typeof fullPrice.formatted === 'string' ?
            new DOMParser().parseFromString(fullPrice.formatted, 'text/html').body.textContent.trim() : '';
          var numberMatch = formattedFullPrice.match(/-?\d[\d\s.,'’]*/);
          if (numberMatch) {
            var savingValue = (fullPrice.amount - price.amount).toFixed(2);
            var decimalMark = numberMatch[0].lastIndexOf(',') > numberMatch[0].lastIndexOf('.') ? ',' : '.';
            savingsAmount = formattedFullPrice.slice(0, numberMatch.index) +
              savingValue.replace('.', decimalMark) +
              formattedFullPrice.slice(numberMatch.index + numberMatch[0].length);
          }
          savingsPercent = Math.round((1 - price.amount / fullPrice.amount) * 100);
        }
      } catch (error) { /* Fall back to selected item count and meals only. */ }
    }
    return {
      quantity: quantity,
      missing: missing,
      incomplete: incomplete,
      total: total,
      savingsAmount: savingsAmount,
      savingsPercent: savingsPercent
    };
  }

  function updateInstallmentAmount(widget, state) {
    var info = widget.closest('.product-info');
    if (!info || !state) return;
    info.querySelectorAll('square-placement').forEach(function (placement) {
      var amount = null;
      if (!state.incomplete && typeof widget.pricing === 'function') {
        try {
          // Kaching's exported pricing() returns the presentment total in major
          // currency units. Keep its discounts, rounding and selected variants.
          amount = widget.pricing().discountedPrice.amount;
        } catch (error) { /* An unfinished/remounting offer has no quote yet. */ }
      }
      var hasAmount = Number.isFinite(amount) && amount >= 0;
      placement.toggleAttribute('data-bfe-incomplete', !hasAmount);
      if (hasAmount && placement.getAttribute('data-amount') !== String(amount)) {
        placement.setAttribute('data-amount', String(amount));
      }
    });
  }

  function updateBundleSummary(widget) {
    var info = widget.closest('.product-info');
    var wrapper = info && info.querySelector(buttonSelector);
    if (!wrapper) return null;
    var state = bundleSelection(widget);
    var preparingPair = widget.getAttribute('data-bfe-default-pair') === 'loading';
    if (preparingPair && state) state.incomplete = true;
    updateInstallmentAmount(widget, state);
    var incomplete = preparingPair || !!(state && state.incomplete);
    if (widget.hasAttribute('data-bfe-incomplete') !== incomplete) widget.toggleAttribute('data-bfe-incomplete', incomplete);
    var summary = widget.parentElement.querySelector('[data-bfe-bundle-summary]');
    var savings = !incomplete && state && state.savingsAmount && state.savingsPercent ?
      state.savingsAmount + ' (' + state.savingsPercent + '%)' : '';
    var text = '';
    var summaryData = null;
    if (preparingPair) {
      text = 'Preparing your recommended pair…';
    } else if (incomplete) {
      text = state.missing === 1 ? 'Choose your second piece to complete the bundle.' : 'Choose the remaining pieces to complete your bundle.';
    } else if (state && state.quantity > 1) {
      summaryData = { total: state.total, items: state.quantity + ' items', savings: savings };
      text = (state.total ? state.total + ' · ' : '') + summaryData.items + (savings ? ' · Save ' + savings : '');
    }
    if (!summary && text) {
      summary = document.createElement('p');
      summary.className = 'bfe-bundle-selection';
      summary.setAttribute('data-bfe-bundle-summary', '');
      summary.setAttribute('role', 'status');
      summary.setAttribute('aria-live', 'polite');
      summary.setAttribute('aria-atomic', 'true');
      widget.insertAdjacentElement('afterend', summary);
    }
    if (summary) {
      if (summary.getAttribute('data-bfe-summary-key') !== text) {
        summary.textContent = '';
        summary.classList.toggle('bfe-bundle-selection--complete', !!summaryData);
        if (summaryData) {
          if (summaryData.total) {
            var total = document.createElement('span');
            total.className = 'bfe-bundle-selection__total';
            total.textContent = summaryData.total;
            summary.appendChild(total);
          }
          var items = document.createElement('span');
          items.className = 'bfe-bundle-selection__items';
          items.textContent = summaryData.items;
          summary.appendChild(items);
          if (summaryData.savings) {
            var saving = document.createElement('span');
            saving.className = 'bfe-bundle-selection__saving';
            saving.textContent = 'Save ' + summaryData.savings;
            summary.appendChild(saving);
          }
        } else {
          summary.textContent = text;
        }
        summary.setAttribute('aria-label', text);
        summary.setAttribute('data-bfe-summary-key', text);
      }
      summary.hidden = !text;
    }
    return state;
  }

  function stickyPurchaseRoot() {
    var root = document.querySelector('[data-bfe-mobile-purchase]');
    if (root) return root;

    root = document.createElement('aside');
    root.className = 'bfe-mobile-purchase-bar';
    root.setAttribute('data-bfe-mobile-purchase', '');
    root.setAttribute('aria-label', 'Selected offer purchase bar');
    root.setAttribute('aria-hidden', 'true');
    root.setAttribute('inert', '');

    var inner = document.createElement('div');
    inner.className = 'bfe-mobile-purchase-bar__inner';

    var summary = document.createElement('p');
    summary.className = 'bfe-mobile-purchase-bar__summary';
    summary.setAttribute('data-bfe-mobile-purchase-summary', '');
    summary.setAttribute('role', 'status');
    summary.setAttribute('aria-live', 'polite');
    summary.setAttribute('aria-atomic', 'true');
    inner.appendChild(summary);

    var button = document.createElement('button');
    button.className = 'bfe-mobile-purchase-bar__button';
    button.type = 'button';
    button.textContent = 'Add to Cart';
    button.tabIndex = -1;
    button.addEventListener('click', function () {
      if (!root.hasAttribute('data-bfe-visible')) return;
      var formId = root.getAttribute('data-bfe-form');
      var wrapper = Array.prototype.find.call(document.querySelectorAll(buttonSelector), function (candidate) {
        return candidate.getAttribute('form') === formId;
      });
      var purchaseButton = wrapper && wrapper.querySelector('button[type="submit"]');
      if (!purchaseButton || purchaseButton.disabled || purchaseButton.getAttribute('aria-disabled') === 'true') return;
      purchaseButton.click();
    });
    inner.appendChild(button);
    root.appendChild(inner);
    document.body.appendChild(root);
    return root;
  }

  function updateStickyVisibility() {
    stickyVisibilityScheduled = false;
    var root = document.querySelector('[data-bfe-mobile-purchase]');
    if (!root) return;
    var formId = root.getAttribute('data-bfe-form');
    var wrapper = Array.prototype.find.call(document.querySelectorAll(buttonSelector), function (candidate) {
      return candidate.getAttribute('form') === formId;
    });
    var purchaseArea = wrapper && wrapper.closest('#bfe-product-purchase');
    var isMobile = window.matchMedia('(max-width: 699px)').matches;
    var ready = root.hasAttribute('data-bfe-ready');
    var pastOffer = purchaseArea && purchaseArea.getBoundingClientRect().bottom <= 0;
    var visible = !!(isMobile && ready && pastOffer);
    var button = root.querySelector('.bfe-mobile-purchase-bar__button');

    root.toggleAttribute('data-bfe-visible', visible);
    root.setAttribute('aria-hidden', visible ? 'false' : 'true');
    root.toggleAttribute('inert', !visible);
    if (button) button.tabIndex = visible ? 0 : -1;
  }

  function scheduleStickyVisibility() {
    if (stickyVisibilityScheduled) return;
    stickyVisibilityScheduled = true;
    window.requestAnimationFrame(updateStickyVisibility);
  }

  function updateMobileStickyPurchase(widget, state) {
    var purchaseArea = widget.closest('#bfe-product-purchase');
    var info = purchaseArea && purchaseArea.closest('.product-info');
    var wrapper = info && info.querySelector(buttonSelector);
    if (!purchaseArea || !wrapper) return;

    var root = stickyPurchaseRoot();
    var summary = root.querySelector('[data-bfe-mobile-purchase-summary]');
    var button = root.querySelector('.bfe-mobile-purchase-bar__button');
    var purchaseButton = wrapper.querySelector('button[type="submit"]');
    var mealsPerProduct = positiveNumber(wrapper.getAttribute('data-bfe-meals-per-product'), 20);
    var complete = !!(state && !state.incomplete && state.quantity > 0 && state.total);
    var text = complete ?
      state.quantity + (state.quantity === 1 ? ' piece' : ' pieces') + ' · ' + state.total + ' · ' +
        (state.quantity * mealsPerProduct) + ' meals' : '';

    root.setAttribute('data-bfe-form', wrapper.getAttribute('form') || '');
    root.toggleAttribute('data-bfe-ready', complete);
    if (summary && summary.textContent !== text) summary.textContent = text;
    if (summary && text) summary.setAttribute('aria-label', text);
    if (button) {
      var disabled = !complete || !purchaseButton || purchaseButton.disabled ||
        purchaseButton.getAttribute('aria-disabled') === 'true';
      button.disabled = disabled;
      button.setAttribute('aria-label', text ? 'Add to cart: ' + text : 'Add selected offer to cart');
    }
    scheduleStickyVisibility();
  }

  function positionBundlePurchaseAction(widget) {
    var info = widget.closest('.product-info');
    var purchaseAction = info && info.querySelector('.product-info__buy-buttons');
    if (!purchaseAction) return;

    var reassurance = info.querySelector('.product-info__block-item[data-block-type="bfe-purchase-reassurance"]');

    function markerFor(element) {
      if (!element) return null;
      var existing = purchaseActionMarkers.get(element);
      if (existing || !element.parentNode) return existing;
      var marker = document.createComment('bfe-purchase-group-origin');
      element.parentNode.insertBefore(marker, element);
      purchaseActionMarkers.set(element, marker);
      return marker;
    }

    var marker = markerFor(purchaseAction);
    var reassuranceMarker = markerFor(reassurance);

    var useInlinePlacement = window.matchMedia('(max-width: 699px)').matches;
    var selected = widget.querySelector('.kaching-bundles__bar--selected');
    var summary = widget.parentElement.querySelector('[data-bfe-bundle-summary]');

    if (useInlinePlacement && selected) {
      purchaseAction.setAttribute('data-bfe-inline-bundle-cta', '');
      if (selected.nextElementSibling !== purchaseAction) selected.insertAdjacentElement('afterend', purchaseAction);
      var lastElement = purchaseAction;
      if (summary) {
        if (lastElement.nextElementSibling !== summary) lastElement.insertAdjacentElement('afterend', summary);
        lastElement = summary;
      }
      if (reassurance) {
        reassurance.setAttribute('data-bfe-inline-bundle-support', '');
        if (lastElement.nextElementSibling !== reassurance) lastElement.insertAdjacentElement('afterend', reassurance);
      }
      return;
    }

    purchaseAction.removeAttribute('data-bfe-inline-bundle-cta');
    if (marker && marker.parentNode && marker.nextSibling !== purchaseAction) {
      marker.parentNode.insertBefore(purchaseAction, marker.nextSibling);
    }
    if (summary && widget.nextElementSibling !== summary) widget.insertAdjacentElement('afterend', summary);
    if (reassurance) {
      reassurance.removeAttribute('data-bfe-inline-bundle-support');
      if (reassuranceMarker && reassuranceMarker.parentNode && reassuranceMarker.nextSibling !== reassurance) {
        reassuranceMarker.parentNode.insertBefore(reassurance, reassuranceMarker.nextSibling);
      }
    }
  }

  function updateAll() {
    scheduled = false;
    document.querySelectorAll('kaching-bundles-block').forEach(function (widget) {
      installBundleValidationGuard(widget);
      selectNewTeePairDefault(widget);
      selectJewelleryPairDefault(widget);
      updateBundleLabels(widget);
      updateTwoPieceSwapControl(widget);
      var state = updateBundleSummary(widget);
      positionBundlePurchaseAction(widget);
      updateMobileStickyPurchase(widget, state);
    });
    document.querySelectorAll(buttonSelector).forEach(updateButton);
  }

  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateAll);
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-bfe-swap-control]');
    if (!control) return;
    var widget = control.closest('kaching-bundles-block');
    if (!widget) return;

    // Let Kaching remove the existing second slot with its own handler, then
    // move directly into its native product chooser instead of leaving the
    // shopper on an incomplete two-piece offer.
    var attempts = 0;
    function openChooser() {
      var chooser = widget.querySelector('.kaching-bundles__bar--selected .kaching-bundles__collection-product__choose-product-button');
      if (chooser) {
        chooser.click();
        return;
      }
      attempts += 1;
      if (attempts < 12) window.requestAnimationFrame(openChooser);
    }
    window.requestAnimationFrame(openChooser);
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target.matches('input[name="quantity"], input[name^="items["][name$="[quantity]"]')) scheduleUpdate();
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest('.product-info, product-quick-add')) scheduleUpdate();
  });
  // Kaching's bubbling events cover preselection, material/size changes,
  // mixed-product bundles and optional items. No submit interception is needed.
  ['kaching-bundles-block-loaded', 'items-changed', 'variants-changed', 'deal-bar-selected',
    'variant:change', 'product:rerender'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleUpdate);
  });
  document.addEventListener('shopify:section:load', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  window.addEventListener('scroll', scheduleStickyVisibility, { passive: true });

  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      if (mutation.target.nodeType === 1 && mutation.target.closest('.product-info, product-quick-add')) return true;
      return Array.prototype.some.call(mutation.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches(buttonSelector + ', kaching-bundles-block') ||
          node.querySelector(buttonSelector + ', kaching-bundles-block'));
      });
    });
    if (relevant) scheduleUpdate();
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  scheduleUpdate();
})();

/* Cart upsells use an inline finish choice so adding another piece never opens
   a second, oversized quick-buy drawer inside the cart. */
(function () {
  document.addEventListener('change', function (event) {
    var choice = event.target.closest('[data-bfe-upsell-variant]');
    if (!choice) return;

    var form = choice.closest('form');
    var card = choice.closest('.bfe-cart-upsell-product');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = choice.value;

    var imageUrl = choice.getAttribute('data-image-url');
    var image = card && card.querySelector('.horizontal-product__image');
    if (imageUrl && image) {
      image.removeAttribute('srcset');
      image.src = imageUrl;
    }
  });
})();
